// extracted by mini-css-extract-plugin
export default {"container":"SplashScreen_container__q9uWR","logo":"SplashScreen_logo__2ooq6","logoGetBigger":"SplashScreen_logoGetBigger__fzIzu","getBigger":"SplashScreen_getBigger__0DYex"};